import { withSvgIcon } from './withSvgIcon';

export const Star = withSvgIcon(
  <path
    d="M11.0959 4.41338C11.4567 3.64969 12.5433 3.64969 12.9041 4.41338L14.7923 8.40913L19.0899 9.07807C19.8917 9.20287 20.2188 10.1803 19.6537 10.7626L16.518 13.9937L17.2381 18.4803C17.37 19.3021 16.4989 19.916 15.7694 19.5153L12 17.4451L8.23061 19.5153C7.50109 19.916 6.62996 19.3021 6.76186 18.4803L7.482 13.9937L4.34628 10.7626C3.78117 10.1803 4.10832 9.20287 4.9101 9.07807L9.20772 8.40913L11.0959 4.41338Z"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
